import { Component, OnInit, Input } from '@angular/core';
import { Response } from '@angular/http';


import {InputMetadataWalker} from 'codelyzer/noInputRenameRule';
import {Model} from '../../entities/model/model.model';
import {SellerDashboardService} from './seller-dashboard.service';
import {ModelImage} from '../../entities/model-image/model-image.model';
import {EventManager} from 'ng-jhipster/src/service/event-manager.service';
import {Principal} from '../../shared/auth/principal.service';
import {JhiLanguageService} from 'ng-jhipster/src/language/language.service';

@Component( {
    selector: 'dcs-seller-model',
    templateUrl: './seller-model.component.html',
    styles: []
} )
export class SellerModelComponent implements OnInit {

    @Input()
    model: Model
    modelImage: ModelImage;

    constructor(private jhiLanguageService: JhiLanguageService,
                private principal: Principal,
                private eventManager: EventManager,
                private sellerService: SellerDashboardService) {

        this.jhiLanguageService.setLocations( [ 'seller', 'model', 'modelImage' ] );
    }

    ngOnInit() {
        this.loadModelImage();
    }

    getScreensaver() {
        if (!this.modelImage || !this.modelImage.screensavers || this.modelImage.screensavers.length == 0)
            return null;
        return this.modelImage.screensavers[ 0 ];
    }

    onReload(reload: boolean) {
        this.loadModelImage();
    }

    private loadModelImage(): void {

        this.sellerService.getModelImage( this.model.id ).subscribe( (res: Response) => {
            //console.log( res );
            this.modelImage = res.json();
        } );
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/seller-dashboard/seller-model.component.ts